import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 26 26",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12.52 3.301a.75.75 0 0 1 .96 0l4.218 3.509a.75.75 0 0 1 0 1.153L13.48 11.47a.75.75 0 0 1-.958 0L8.3 7.963a.75.75 0 0 1 0-1.153zM9.955 7.386 13 9.92l3.046-2.533L13 4.853zM5.49 8.915a.75.75 0 0 1 .96 0l4.218 3.508a.75.75 0 0 1 0 1.153l-4.219 3.508a.75.75 0 0 1-.959 0l-4.22-3.507a.75.75 0 0 1 0-1.153zm14.063 0a.75.75 0 0 1 .959 0l4.219 3.508a.75.75 0 0 1 0 1.153l-4.22 3.508a.75.75 0 0 1-.958 0l-4.219-3.508a.75.75 0 0 1 0-1.153zM2.923 13l3.046 2.532L9.015 13l-3.046-2.533zm14.062 0 3.046 2.532L23.077 13l-3.046-2.533zm-8.683 5.036 4.219-3.508a.75.75 0 0 1 .958 0l4.22 3.508a.75.75 0 0 1 0 1.153l-4.22 3.509a.75.75 0 0 1-.958 0L8.3 19.189a.75.75 0 0 1 0-1.153m1.652.577L13 21.146l3.046-2.533L13 16.08z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=WorkAppIcon26.js.map